<template>
  <b-row no-gutters style="padding: 6px">
    <b-col style="padding: 0%; padding-right: 15px">
      <b-button :class="modalTheme" @click="clearTaskRecords" v-show="taskbuilderStore.taskRecords" type="button" variant="primary-green" size="sm"> Clear </b-button>
    </b-col>

    <b-col style="padding: 0%">
      <b-button :class="modalTheme" size="sm" class="tasks-button no-wrap" variant="primary-green" :disabled="disabled" v-b-toggle.sidebarTask>
        {{ props.context ? props.context.title : "Task Builder" }}
      </b-button>
    </b-col>

    <b-sidebar
      no-header
      id="sidebarTask"
      :width="userSideBarWidth + '%'"
      ref="sideBar"
      title="Create Task/Message"
      v-model="isCreateTaskFormSidebarOpen"
      :sidebar-class="modalTheme"
      :body-class="modalTheme"
      :header-class="modalTheme"
      backdrop
      right
      shadow
    >
      <template #default="{ hide }">
        <div class="d-flex align-items-center px-3 py-2">
          <b-button :class="modalTheme" size="sm" @click="hide" style="margin-left: 0px">&times;</b-button>
          <h3 class="mr-auto"><strong class="mr-auto" style="margin-left: 300px">Create Task/Message</strong></h3>
        </div>
        <!-- Sidebar content goes here -->

        <div style="background: transparent; padding: 3px; overflow: hidden" :class="modalTheme">
          <span v-if="AreIdsShown" style="background: transparent; padding: 0px; overflow: hidden">
            <span style="background: blue; color: yellow"> {{ taskbuilderStore.getAllTaskRecords?.length }}</span>
            <br />
            <div style="background: red; color: yellow; max-height: 72px; overflow-y: auto">{{ taskbuilderStore.getAllTaskRecords }}</div>
            <br
          /></span>
          <CreateNewTask class="form" :context="props.context" :records="props.records" @createNewTask="onSubmitCreateNewTask" />
        </div>
      </template>
    </b-sidebar>
  </b-row>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
// * STOREs
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
import { useStoreTaskBuilder } from "@/stores/taskBuilderStore";
const patientStore = usePatientStore();
const taskbuilderStore = useStoreTaskBuilder();

// * API
import { createNewTasks } from "@/api/discreteDataApi";

import CreateNewTask from "@/modules/Messaging/CreateNewTask.vue";

// & PROPS
const props = defineProps({
  records: {
    type: Array,
    default: () => [],
  },
  context: {
    type: Object,
    default: () => [],
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const variant = "dark-green";

const isCreateTaskFormSidebarOpen = ref(false);

const userSideBarWidth = ref(35);

async function onSubmitCreateNewTask(payload) {
  // console.clear();
  // console.log(" 	onSubmitCreateNewTask						PAYLOAD: ", payload);

  if (payload.includeContext) {
    payload.patientId = patientStore.currentPatientId;
  } else {
    payload.patientId;
  }

  // console.log("  this.tPatientId					Check	REBIND	PAYLOAD.patientId:", payload.patientId);

  // console.log(payload);

  ////console.clear()()
  // console.log('>>>>>>>>>>>>>>>>>>>>>>>  Check	REBIND	PAYLOAD.selectedTaskRecords:',				payload.selectedTaskRecords.length			)
  // toastrWarning(' WIRE UP api CreateNewTasks() ')
  // toastrSuccess("Successfully Created Task");
  // toastrSuccess(payload)
  // console.log(" 																																				PAYLOAD: ", payload);

  const response = await createNewTasks(payload);

  if (response.ok) {
    // this.isCreateTaskFormSidebarOpen = false;
    isCreateTaskFormSidebarOpen.value = false;

    // console.log(' createNewTasks			>>>>		response  ok ')

    clearTaskRecords();
  }

  //! Clear localStorage
  // console.log('		LOCAL Stor')
  // console.dir(localStorage);
  // console.log('				onSubmitCreateNewTask   - 	CLEAR 		LOCAL Stor')
  localStorage.clear();
  // console.dir(localStorage);
  //	this.$emit(CreateNewTask, response)
}

function clearTaskRecords() {
  // // console.log(' Created 	sTaskRecords: ', this.sTaskRecords)

  // console.log(' 		STORE taskBuilder TaskRecords')

  taskbuilderStore.taskRecords = [];

  // console.dir(taskbuilderStore.taskRecords);
}

onMounted(() => {
  // console.log("onMounted() :      Create new Task  button   sidebar  >>>>");
  // console.log("props : ");
  // console.log(props);
  // console.log(" prop   records ");
  // console.log(props.records);
  // console.log(" prop   context ");
  // console.log(props.context);
});
</script>

<!-- <script>
import CreateNewTask from '@/modules/Messaging/CreateNewTask.vue'
import { CreateMessageDone } from '@/modules/Messaging/messagingDomain'
import { createMessagePostFromForm } from '@/modules/Messaging/messagingDomain'
import { mapActions } from 'vuex'
import { mapGetters, mapState } from 'vuex'
import { toastrSuccess, toastrWarning, toastrError } from '@/utilities/toastr'

import { createNewTasks } from '@/api/discreteDataApi'

import bFormSlider from 'vue-bootstrap-slider/es/form-slider'
import 'bootstrap-slider/dist/css/bootstrap-slider.css'

export default {
	components: {
		CreateNewTask,
		bFormSlider,
	},
	props: {
		records: {
			type: Array,
			required: true,
			default: () => [],
		},
		disabled: {
			type: Boolean,
		},
		context: {
			type: Object,
			required: false,
		},
	},
	data() {
		return {
			userSideBarWidth: 35,
			rangeValue: [25, 75],
			ticks: [20, 30, 40, 50],
			tickLabels: ['20', '30', '40', '50'],
			showModal: false,
			isCreateTaskFormSidebarOpen: false,
			variant: 'dark-green',
			variants: [
				'transparent',
				'white',
				'light',
				'dark',
				'primary',
				'secondary',
				'success',
				'danger',
				'warning',
				'info',
			],
		}
	},
	computed: {
		...mapState({
			patientId: (state) => state.patient.currentPatientId,
		}),
		...mapGetters(['currentPatient']),
		data() {
			return {
				patient: this.currentPatient,
			}
		},
	},
	methods: {
		...mapActions({
			createNewMessage: 'createNewMessage',
		}),
		async onSubmitCreateNewTask(payload) {
			//	//console.clear()()
			// console.log(' 							PAYLOAD: ', payload)
			// console.log('...											...											...		ON SUBMITTAL < payload')
			// // console.log('   selected records on SUBMIT ')

			// // console.log(' 			P id: ' + this.patientId + ' ')
			// // console.log('							PAYLOAD: ', payload)
			// // console.log('							PAYLOAD: recipients ', payload.recipients.length)
			// // console.log(' 						PAYLOAD:  recipientsCC', payload.recipientsCC.length)
			// // console.log(' 						PAYLOAD.taskTypes:', payload.taskTypes)

			// console.log(' 				  this.patientId:', this.patientId)
			// console.log(' 				  	REBIND	PAYLOAD.s:', payload.patientId)

			const tPatientId = 0

			// console.log(' 	**** BIND patientId:			 payload.includeContext:',		payload.includeContext	)

			// console.log('	  this.patientId:', this.patientId)

			if (payload.includeContext) {
				payload.patientId = this.patientId
			} else {
				payload.patientId
			}

			// console.log(payload.patientId)
			// console.log('  this.tPatientId					Check	REBIND	PAYLOAD.patientId:',payload.patientId)

			////console.clear()()
			// console.log('>>>>>>>>>>>>>>>>>>>>>>>  Check	REBIND	PAYLOAD.selectedTaskRecords:',				payload.selectedTaskRecords.length			)
			// toastrWarning(' WIRE UP api CreateNewTasks() ')
			// toastrSuccess('Successfully Created Task')
			// toastrSuccess(payload)
			// console.log(' 																																				PAYLOAD: ', payload)

			const response = await createNewTasks(payload)

			if (response.ok) {
				this.isCreateTaskFormSidebarOpen = false

				// console.log(' createNewTasks			>>>>		response  ok ')

				// EMT clearTaskRecords
				this.$emit('clearTaskRecords', payload)
			}

			//! Clear localStorage
			// console.log('		LOCAL Stor')
// console.dir(localStorage)
			// console.log('				onSubmitCreateNewTask   - 	CLEAR 		LOCAL Stor')
			localStorage.clear()
// console.dir(localStorage)
			//	this.$emit(CreateNewTask, response)
		},
		slideStart() {
			// console.log('slideStarted')
			this.setSideBarWidth()
		},
		slideStop() {
			// console.log('slideStopped')
		},
		setSideBarWidth() {
			// // this.$refs.sideBar.clientWidth = 75%
			// // "20%"
			// var incW = this.userSideBarWidth + '%'
			// // this.result = incW / screen.width + 'px'
			// this.$refs.sideBar.width = this.result
			// // console.log('SET text : ' + this.$refs.sideBar.width)
			// // console.log('SET text : ' + this.$refs.sideBar.clientWidth)
		},
		clearTaskRecords() {
			// // console.log(' Created 	sTaskRecords: ', this.sTaskRecords)

			// console.log(' 		STORE taskBuilder TaskRecords')

			taskbuilderStore.taskRecords = []

// console.dir(taskbuilderStore.taskRecords)
		},
	},
}
</script> -->

<style lang="scss" scoped>
.form {
  margin: 0 auto;
  width: 90%;
}
.tasks-button {
  // background-color:orange;
  //  height: 20px;
  padding-top: 0px;
}
.btn-primary-green {
  color: #007bff;
  border: none;
  text-decoration: none;
  background-color: transparent;
}
.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}
.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}
</style>
